export function isAllowedPooling(): boolean {
  const pollingIntervalsFromLocalStorage = getUrlsAllowedForPolling();
  const isAllowedUrl = pollingIntervalsFromLocalStorage?.some((url) =>
    window.location.pathname.includes(url)
  );
  return isAllowedUrl;
}

function getUrlsAllowedForPolling(): string[] {
  const KEEPER_ALLOWED_URLS_FOR_POLLING: string[] = [
    'pending-orders',
    'orders-map',
    'order-list',
    'inventory',
    'financial-reports',
    'performance',
    'store-list',
    'account-information',
    'support',
    'finished-order-details',
    'order-details',
  ];

  const pollingIntervalsFromLocalStorage: string[] | undefined = load(
    'urlsAllowedForPolling'
  );

  if (
    pollingIntervalsFromLocalStorage &&
    Array.isArray(pollingIntervalsFromLocalStorage) &&
    pollingIntervalsFromLocalStorage.length
  ) {
    return pollingIntervalsFromLocalStorage;
  } else {
    return KEEPER_ALLOWED_URLS_FOR_POLLING;
  }
}

function load(key: string) {
  try {
    const userPreference = JSON.parse(
      localStorage.getItem('userPreference') || '{}'
    );
    return userPreference[key] ?? null;
  } catch {
    return null;
  }
}
